import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/common/Reveal";
import { useQuote } from "@/context/QuoteContext";
import { COMPANY } from "@/data/site";

export default function CTASection() {
  const { openQuote } = useQuote();
  return (
    <section data-testid="cta-section" className="relative bg-gema-red overflow-hidden">
      {/* subtle diagonal texture reminiscent of brochure */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{ backgroundImage: "repeating-linear-gradient(135deg, #000 0 2px, transparent 2px 24px)" }}
      />
      <div className="container-gema relative z-10 py-24 md:py-32 text-center">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-white/70">Estamos listos para ayudarte</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="heading-lg text-white mt-6 max-w-3xl mx-auto">
            ¿Necesitas una solución técnica confiable?
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-white/80 mt-6 max-w-2xl mx-auto leading-relaxed">
            Nuestro equipo está listo para asesorarte y ofrecerte la mejor solución para tu proyecto,
            vehículo o equipo. Contáctanos y recibe atención personalizada.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              data-testid="cta-quote-btn"
              onClick={() => openQuote()}
              className="inline-flex items-center justify-center gap-2 bg-black text-white px-8 py-4 font-heading font-bold uppercase tracking-wider text-sm hover:bg-gema-ink transition-colors duration-300"
            >
              Solicitar Cotización <ArrowRight className="h-4 w-4" />
            </motion.button>
            <a
              href={COMPANY.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-whatsapp-btn"
              className="inline-flex items-center justify-center gap-2 border border-white/40 text-white px-8 py-4 font-heading font-bold uppercase tracking-wider text-sm hover:bg-white hover:text-gema-red transition-colors duration-300"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
